import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import Themed from 'store/v2/react/components/Themed'

import CollectionList from 'store/modules/product/components/CollectionList'

const store = window.booqableStore

export default class CollectionListContainer extends Component {
  static displayName = 'CollectionListContainer'

  static propTypes = {
    searchKey: PropTypes.string
  }

  render () {
    return (
      <Provider store={store}>
        <Themed>
          <div className="booqable-component" style={{ display: 'none' }}>
            <CollectionList {...this.props} filterKey={this.props.searchKey} />
          </div>
        </Themed>
      </Provider>
    )
  }
}
